import { Suspense } from 'react';

import { getAccountsQueryConfig } from '@api/lendingAPI/queryConfigs';
import { TAccount } from '@helpers/Accounts/accounts.types';
import { useQuery } from '@tanstack/react-query';
import { Skeleton } from '@ui';

import { ErrorBoundary } from '../../../../errorBoundary/ErrorBoundary';
import { useStateKey } from '../../../../iwQueryClient/useStateKey';
import FallbackErrorModal from '../../../modals/fallbackErrorModal/FallbackErrorModal';
import { OverdueAlert } from '../../NewOverdueView/OverdueAlert';

export const OverdueAlertBanner = ({
    accountId
}: {
    accountId: NonNullable<TAccount['account_id']>;
}) => {
    return (
        <ErrorBoundary
            fallback={(error) => <FallbackErrorModal error={error} />}
        >
            <Suspense
                fallback={
                    <Skeleton
                        data-testid="overdue-alert-banner-skeleton"
                        className="h-[60px] w-full rounded-s"
                    />
                }
            >
                <OverdueAlertContent accountId={accountId} />
            </Suspense>
        </ErrorBoundary>
    );
};

const OverdueAlertContent = ({
    accountId
}: {
    accountId: NonNullable<TAccount['account_id']>;
}) => {
    const stateKey = useStateKey();
    const { data: account } = useQuery({
        ...getAccountsQueryConfig(stateKey),
        select: (data) =>
            data.data.accounts.find((acc) => acc.account_id === accountId),
        suspense: true
    });

    const overdueAmount = account?.scheduled_payments?.schedule?.[0]?.total;

    if (!overdueAmount) return null;

    return <OverdueAlert overdueAmount={overdueAmount} />;
};
